import React from 'react'
import TablePersonalAttributes from '../components/TablePersonalAttributes'

export default function PagePersonalAttributes() {
  return (
    <React.Fragment>
      <div className="containerMainPage">
        <TablePersonalAttributes />
      </div>
    </React.Fragment>
  )
}
